import React, { useContext } from "react";
import headerImg from "../assets/img/curved-images/curved14.jpg";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";
import $ from "jquery";
import AuthContext from "../controllers/auth";
import NavBar from "../components/NavBar";
import CloudCtx from "../controllers/cloud";

const SignUp = () => {
  const authCtx = useContext(AuthContext);
  const cloudCtx = useContext(CloudCtx);
  const students = cloudCtx.students;
  const onSubmit = (e) => {
    e.preventDefault();
    let email = $("#email").val().trim();
    let password = $("#password").val().trim();
    let first = $("#first").val().trim();
    let surname = $("#surname").val().trim();
    let other = $("#other").val().trim();

    authCtx.sign({
      first: first,
      email: email,
      surname: surname,
      password: password,
      students: students && students,
      other: other,
    });
  };

  return (
    <div>
      <NavBar />
      <header>
        <div className="page-header min-vh-100">
          <div>
            <img
              className={
                "position-absolute fixed-top ms-auto w-lg-50 w-md-50 h-100 z-index-0 d-md-block border-radius-section border-top-end-radius-0 border-top-start-radius-0 border-bottom-end-radius-0"
              }
              src={headerImg}
              alt="img"
            />
          </div>
          <Container className="">
            <div className="row">
              <Col
                lg={7}
                md={8}
                sm={12}
                className="d-flex justify-content-center flex-column mx-auto "
              >
                <Card className="d-flex blur justify-content-center p-4 shadow-lg my-sm-0 my-sm-6 mt-8 mb-5">
                  <div className="text-center">
                    <h3 className="text-gradient text-danger">Sign Up</h3>
                    <p className="mb-0">
                      All fields with <span className="text-danger text-gradient">*</span> are required.
                    </p>
                  </div>
                  <Form onSubmit={onSubmit}>
                    <CardBody className="pb-2 px-0">
                      <Row>
                        <Col xs={6} className="">
                          <label>First Name <span className="text-danger text-gradient">*</span></label>
                          <div className="input-group mb-4">
                            <Input
                              className=""
                              type="text"
                              id={"first"}
                              required
                            />
                          </div>
                        </Col>
                        <Col xs={6} className="">
                          <Label>Surname <span className="text-danger text-gradient">*</span></Label>
                          <div className="input-group">
                            <Input
                              type="text"
                              className=""
                              id={"surname"}
                              required
                            />
                          </div>
                        </Col>
                        <Col xs={6} className="">
                          <Label>Other name</Label>
                          <div className="input-group">
                            <Input type="text" className="" id={"other"} />
                          </div>
                        </Col>

                        <Col xs={6} className="">
                          <label>Email <span className="text-danger text-gradient">*</span></label>
                          <div className="input-group mb-4">
                            <Input
                              className=""
                              type="email"
                              id={"email"}
                              required
                            />
                          </div>
                        </Col>
                        <Col xs={6} className="">
                          <Label>Password <span className="text-danger">* (minimum of 6 characters)</span></Label>
                          <div className="input-group">
                            <Input
                              type="password"
                              className=""
                              id={"password"}
                              required
                            />
                          </div>
                        </Col>
                      </Row>

                      <Row className="">
                        <Col md={12} className="text-center">
                          <Button
                            type="submit"
                            className="btn bg-gradient-danger mt-3 mb-0"
                          >
                            Create Account
                          </Button>
                        </Col>
                      </Row>
                    </CardBody>
                  </Form>
                </Card>
              </Col>
            </div>
          </Container>
        </div>
      </header>
    </div>
  );
};

export default SignUp;
